import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen, CalendarDays } from 'lucide-react';
import { TID } from '@/lib/testIds';
import { PUBLIC_MENU_ENABLED } from '@/lib/launchMode';

const ALL_ITEMS = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/menu', icon: BookOpen, label: 'Menu', menuOnly: true },
  { to: '/book', icon: CalendarDays, label: 'Book' },
];

export const BottomTabNav = () => {
  const { pathname } = useLocation();
  const items = ALL_ITEMS.filter((i) => !i.menuOnly || PUBLIC_MENU_ENABLED);
  const gridCols = items.length === 2 ? 'grid-cols-2' : items.length === 3 ? 'grid-cols-3' : 'grid-cols-4';
  return (
    <nav
      data-testid={TID.nav.bottom}
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[hsl(var(--sb-surface))]/95 backdrop-blur border-t border-[hsl(var(--sb-border))]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className={`grid ${gridCols}`}>
        {items.map(({ to, icon: Icon, label }) => {
          const active = to === '/' ? pathname === '/' : pathname.startsWith(to);
          return (
            <li key={to}>
              <Link
                to={to}
                className={`flex flex-col items-center justify-center gap-1 py-2.5 transition-colors ${active ? 'text-[hsl(var(--sb-gold))]' : 'text-white/65 hover:text-white'}`}
              >
                <Icon size={20} />
                <span className="text-[11px] font-medium">{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
